import { render, staticRenderFns } from "./ChatMessageActions.vue?vue&type=template&id=7f480127&"
import script from "./ChatMessageActions.vue?vue&type=script&lang=js&"
export * from "./ChatMessageActions.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports